import Modal from 'react-modal';

// Definir el elemento de la aplicación para react-modal
Modal.setAppElement('#root');
